import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router, RouterLink} from '@angular/router';
import {SimplebarAngularModule} from 'simplebar-angular';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-admin-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    SimplebarAngularModule,
    TranslateModule
  ],
  templateUrl: './admin-sidebar.component.html',
  styleUrl: './admin-sidebar.component.scss'
})
export class AdminSidebarComponent {
  menu: any;
  subManu: any;

  constructor(private readonly router: Router) {
    this.menu = this.router.url;
    window.scrollTo(0, 0);
  }

  openMenu(e: any, item: any) {
    e.preventDefault();

    if (this.subManu === item) {
      this.subManu = '';
    } else {
      this.subManu = item;
    }
  }

  protected readonly ARTICLES_MENU_LIST = [
    '/piglet/articles/list',
    '/piglet/articles/categories',
    '/piglet/articles/category-types',
    '/piglet/articles/edit',
    '/piglet/articles/create'
  ];

  protected readonly SETTINGS_MENU_LIST = [
    '/piglet/settings/application-settings',
  ];
}
